(function () {
    const header = document.querySelector('.header-dynamic');
    const occasionStickyInfo = document.querySelector('.occasion-sticky-info');
    const padding = 24;

    const meta = document.querySelector('.op-meta-desktop');

    function setStickyMetaTop() {
        const offset = header.offsetHeight + padding;
        meta.style.top = `${offset}px`;
    }

    function setStickyMetaTopScroll() {
        const headerUp = header.attributes.up !== undefined || header.attributes.down === undefined;
        const headerDown = header.attributes.down !== undefined;
        const occasionStickyInfoScrolled = occasionStickyInfo.attributes.scrolled !== undefined ? 1 : 0;

        const headerUpOffset  = `${header.offsetHeight + padding + (occasionStickyInfo.offsetHeight * occasionStickyInfoScrolled)}px`;
        const headerDownOffset = `${padding + (occasionStickyInfo.offsetHeight * occasionStickyInfoScrolled)}px`;

        if (headerDown && meta.style.top !== headerDownOffset) {
            meta.style.top = headerDownOffset;
        }
        if (headerUp && meta.style.top !== headerUpOffset) {
            meta.style.top = headerUpOffset;
        }
    }

    if (meta === null) {
        return;
    }

    meta.style.position = 'sticky';
    setStickyMetaTop();

    /**
     * Update the offset whenever a resize
     */
    window.addEventListener('resize', () => {
        requestAnimationFrame(() => {
            setStickyMetaTop();
        });
    });

    /**
     * Update the offset on scroll
     */
    window.addEventListener('scroll', () => {
        requestAnimationFrame(() => {
            setStickyMetaTopScroll();
        });
    });
})();



// WEBPACK FOOTER //
// ./scripts/custom/occasions/occasionDetailMeta.js